var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitLab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2249 36.5899L57.942 26.3701L51.4361 6.11487C51.1014 5.07282 49.6439 5.07282 49.3091 6.11487L42.8029 26.3701H21.1981L14.6917 6.11487C14.3571 5.07282 12.8996 5.07282 12.5647 6.11487L6.05877 26.3701L2.77618 36.5899C2.47663 37.5221 2.80477 38.5433 3.58858 39.1194L31.9999 60L60.4112 39.1194C61.195 38.5432 61.5243 37.5221 61.2249 36.5899Z",
    fill: "#FC6D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 60L42.5052 26.3733H21.1719L31.9999 60Z",
    fill: "#E24329"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02523 26.4098L2.77611 36.7964C2.47672 37.7203 2.80469 38.7325 3.58866 39.3034L31.9998 60L6.02523 26.4098Z",
    fill: "#FCA326"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1626 26.26H21.3934L15.0299 6.12591C14.7056 5.06903 12.7293 5.06903 12.4052 6.12591L6.1626 26.26Z",
    fill: "#E24329"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9619 26.374L61.2237 36.7964C61.5231 37.7203 61.1951 38.7325 60.4112 39.3034L32 60L57.9619 26.374Z",
    fill: "#FCA326"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8382 26.3271H42.5244L48.9696 6.126C49.2939 5.06911 51.3532 5.06911 51.6774 6.126L57.8382 26.3271Z",
    fill: "#E24329"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitLab);
export default __webpack_public_path__ + "static/media/GitLab.bc30711f68ac697313124d432516af91.svg";
export { ForwardRef as ReactComponent };